import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "case-image",
      style: {
        width: `${_vm.imageWidth}px`,
      },
      attrs: { "data-qa": "case-image" },
    },
    [
      _c(VImg, {
        staticClass: "case-image__image elevation-1 cursor-pointer",
        attrs: {
          src: _vm.caseImage.photo_preview,
          width: _vm.imageWidth,
          height: _vm.imageHeight,
          "max-height": _vm.imageHeight,
          "max-width": _vm.imageWidth,
          "data-slide-index": _vm.index,
          contain: "",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-body-2 text-secondary--text mt-2" }, [
        _vm._v(_vm._s(_setup.getPeriodText(_vm.caseImage))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }